import React from 'react';
import { CircleSessionBookingStatus } from '@modernhealth/circles-graphql';
import { formatCircleBookingStatus } from '@modernhealth/circles-web-components';
import { useTranslation } from 'react-i18next';

import { captureException } from 'src/shared/helpers/captureException';

function translationKey(circleBookingStatus: CircleSessionBookingStatus) {
    switch (circleBookingStatus) {
        case CircleSessionBookingStatus.FullyBooked:
            return 'pages.topic.registration.booking_status.fully_booked';
        case CircleSessionBookingStatus.LimitedAvailability:
            return 'pages.topic.registration.booking_status.limited_availability';
        case CircleSessionBookingStatus.ManySpotsAvailable:
            return 'pages.topic.registration.booking_status.many_spots_left';
        case CircleSessionBookingStatus.SpotsAvailable:
            return 'pages.topic.registration.booking_status.spots_available';
        default:
            captureException(new Error(`Unhandled Circle booking status ${circleBookingStatus}`));
            return '';
    }
}

export const TranslatedCircleSessionBookingStatus = ({
    status,
}: {
    status: CircleSessionBookingStatus;
}) => {
    const { t } = useTranslation('circles');
    const tKey = translationKey(status);

    return (
        <>
            {t([formatCircleBookingStatus(status), tKey], {
                /* Our "keys" have spaces in them, so look them up directly.*/
                ignoreJSONStructure: true,
            })}
        </>
    );
};
